"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCustomerSelection = void 0;
var _mui = require("@ori-ui/mui");
const StyledCustomerSelection = exports.StyledCustomerSelection = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  rowGap: theme.spacing(1),
  maxHeight: '60vh',
  marginTop: theme.spacing(3),
  width: '100%',
  overflow: 'visible'
}));
